
<div class="estimate-details-main-page">
  <nav class="navbar navbar-expand-lg classic transparent navbar-light"  [class.navbar-white]="isNavbarWhite" style="padding-top: 0 !important;">
        <div class="container flex-lg-row flex-nowrap align-items-center nav-bar">
            <div
            class="navbar-collapse-wrapper d-flex flex-row flex-nowrap w-100 justify-content-between align-items-center padding" >
            <div class="logo-wth-txt d-flex align-items-center gap-3 nav-logo clickable"
                (click)="goToGarageDetails()" style="padding: 0px 20px; cursor:pointer;">
              <span class="nav-link">Home</span>
            </div>
            <div class="d-lg-none me-2 qck-bkng" *ngIf="showQuickBooking">
                <button
                    class="btn btn-sm btn-outline-primary rounded-pill qck-bkng-btn"
                    (click)="openRequestModal()">
                    Quick Booking
                </button>
            </div>
            <button
                class="navbar-toggler d-lg-none mat-hamburger-btn"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target=".offcanvas-nav"
                aria-label="Toggle navigation"
            >
                <mat-icon>menu</mat-icon>
            </button>

            </div>

            <div class="navbar-collapse offcanvas offcanvas-nav offcanvas-start">
            <div class="offcanvas-header d-lg-none">
                <h3 class="text-white fs-30 mb-0"> {{ garageShortName }}</h3>
                <button
                type="button"
                class="btn-close btn-close-white"
                data-bs-dismiss="offcanvas"
                ></button>
            </div>

            <div class="offcanvas-body ms-lg-auto d-flex flex-column h-100">
                <ul class="navbar-nav align-items-center-abt">
                  <li class="nav-item" style="cursor: pointer;">
                    <a class="nav-link" (click)="scrollTo('service-description')" data-bs-dismiss="offcanvas">
                      Service Details
                    </a>
                  </li>

                  <li class="nav-item"  style="cursor: pointer;">
                    <a class="nav-link" (click)="scrollTo('whats-included')" data-bs-dismiss="offcanvas">
                      What’s Included
                    </a>
                  </li>

                  <li class="nav-item"  style="cursor: pointer;">
                    <a class="nav-link" (click)="scrollTo('faqs')" data-bs-dismiss="offcanvas">
                      FAQs
                    </a>
                  </li>

                  <li class="nav-item book" *ngIf="showRequestBtn">
                    <button
                      class="btn btn-lg btn-outline-white rounded-pill rqstbtn"
                      data-bs-toggle="modal"
                      data-bs-target="#requestCallBackModal"
                      data-bs-dismiss="offcanvas">
                      Book an Appointment
                    </button>
                  </li>
                </ul>


            </div>
            </div>
        </div>
    </nav>
  <div class="container">
  <div class="grid">
    <!-- LEFT COLUMN -->
    <div class="left-col">
      <h1>Service Details</h1>
      <div class="service-header">
        <img src="../../../assets/img/estimate-image.jpg">
        <div class="svc-info">
          <div>
          <!-- <p class="meta" [ngClass]="{'collapsed': !showFullDescription}" *ngIf="fromPage !== 'denting-painting'">
            {{ serviceDetail.serviceKitDefinition.description ?? 'Details not available'}}
          </p>
          <span 
            *ngIf="serviceDetail.serviceKitDefinition.description?.length > 150"
            class="toggle-btn"
            (click)="toggleDescription()"
          >
            <mat-icon class="toggle-icon">
              {{ showFullDescription ? 'expand_less' : 'expand_more' }}
            </mat-icon>
            {{ showFullDescription ? 'Show Less' : 'Show More' }}
          </span> -->

          <p class="meta" [ngClass]="{'collapsed': !showFullContent}" *ngIf="fromPage === 'denting-painting'">
            {{ serviceDetail.serviceKitDefinition.content ?? 'Details not available' }}
          </p>

          <span 
            *ngIf="serviceDetail.serviceKitDefinition.content?.length > 150 && fromPage === 'denting-painting'"
            class="toggle-btn"
            (click)="toggleContent()"
          >
            <mat-icon class="toggle-icon">
              {{ showFullContent ? 'expand_less' : 'expand_more' }}
            </mat-icon>
            {{ showFullContent ? 'Show Less' : 'Show More' }}
          </span>

        <div>
             <!-- <div style="display: flex; justify-content: space-between;">
                <div class="time-tag" *ngIf="serviceDetail.parts.length && serviceDetail.parts[0]?.deliveryTime">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 5.83333V8.5L10 10.5M14 8.5C14 9.28793 13.8448 10.0681 13.5433 10.7961C13.2417 11.5241 12.7998 12.1855 12.2426 12.7426C11.6855 13.2998 11.0241 13.7417 10.2961 14.0433C9.56815 14.3448 8.78793 14.5 8 14.5C7.21207 14.5 6.43185 14.3448 5.7039 14.0433C4.97595 13.7417 4.31451 13.2998 3.75736 12.7426C3.20021 12.1855 2.75825 11.5241 2.45672 10.7961C2.15519 10.0681 2 9.28793 2 8.5C2 6.9087 2.63214 5.38258 3.75736 4.25736C4.88258 3.13214 6.4087 2.5 8 2.5C9.5913 2.5 11.1174 3.13214 12.2426 4.25736C13.3679 5.38258 14 6.9087 14 8.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  {{ serviceDetail.parts[0].deliveryTime }}
                </div>
                <div class="service-meta-tag" *ngIf="serviceMetaInfo">
                  <div class="meta-line">
                    <mat-icon>schedule</mat-icon>
                    {{ serviceMetaInfo.time }}
                  </div>
                  <div class="meta-line" style="padding: 0px 10px 5px 10px;">
                    <mat-icon>autorenew</mat-icon>
                    {{ serviceMetaInfo.interval }}
                  </div>
                </div>
            </div> -->
      </div>

          </div>
        </div>
      </div>
    </div>

    <!-- RIGHT COLUMN -->
    <div class="right-col" *ngIf="key !== 'laksh'">
      <div class="card">
        <h3>Parts Breakdown</h3>
        <table class="parts-table">
          <thead style="background: white !important;">
            <tr>
              <th>PART</th>
              <th>BRAND</th>
              <th class="text-right">MRP (Unit)</th>
              <th class="text-right">Qty</th>
              <th class="text-right">MRP (Total)</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let part of serviceDetail.parts">
              <td>{{ part.partName || 'Pending' }}</td>
              <td>{{ part.brandName || 'Pending' }}</td>
              <td class="text-right">
                <span *ngIf="part.zohoPartPrice !== null; else pendingPrice">₹{{ part.zohoPartPrice }}</span>
                <ng-template #pendingPrice><span class="pending-tag">Pending</span></ng-template>
              </td>
              <td class="text-right"><span class="pending-tag-qty">{{ part.quantity }}</span></td>
              <td class="text-right">
                <span *ngIf="part.zohoPartPrice !== null; else pendingTotal">₹{{ part.zohoPartPrice }}</span>
                <ng-template #pendingTotal><span class="pending-tag">Pending</span></ng-template>
              </td>
            </tr>

            <tr *ngIf="serviceDetail.parts.length === 0">
              <td colspan="5">No parts available.</td>
            </tr>
          </tbody>
        </table>

        <div class="summary-row total">
          <span>Parts Subtotal:</span>
          <span class="amount">
            ₹{{ partsSubtotal }}
            <ng-container *ngIf="hasPendingParts">
              <span class="pending-text">+ pending</span>
              <span 
                class="info-icon"
                (click)="showPendingInfo = !showPendingInfo"
              >?</span>

              <div class="pending-info" *ngIf="showPendingInfo">
                Awaiting price for 
                <span *ngFor="let part of pendingPartNames; let i = index">
                  {{ part }}<span *ngIf="i < pendingPartNames.length - 1">, </span>
                </span>
              </div>
            </ng-container>
          </span>
        </div>
      </div>

      <div class="card">
        <h3>Labour Breakdown</h3>
        <div *ngFor="let labour of serviceDetail.labours" class="summary-row">
          <span>{{ labour.labourName || 'Pending' }}</span>
          <span>
            <ng-container *ngIf="labour.labourRate !== null; else pendingLabour">
              ₹{{ labour.labourRate }}
            </ng-container>
            <ng-template #pendingLabour><span class="pending-tag">Pending</span></ng-template>
          </span>
        </div>

        <div class="summary-row total">
          <span>Labour Subtotal:</span>
          <span *ngIf="labourSubtotal !== null; else pendingLabourTotal">₹{{ labourSubtotal }}</span>
          <ng-template #pendingLabourTotal><span class="pending-tag">Pending</span></ng-template>
        </div>
      </div>

      <div class="cost-summary">
        <h3>Cost Summary</h3>

        <div class="summary-row">
          <span class="label">Parts Subtotal</span>
          <span class="value pending">₹{{ partsSubtotal }}</span>
        </div>

        <div class="summary-row">
          <span class="label">Labour Subtotal</span>
          <span class="value">₹{{ labourSubtotal || 0 }}</span>
        </div>

        <div class="summary-row">
          <span class="label">Taxes ({{ labourGstRate ? labourGstRate + '%' : 'N/A' }} GST)</span>
          <span class="value pending">{{ labourGstRate ? labourGstRate + '%' : 'Pending' }}</span>
        </div>

        <div class="estimated-box">
          <span class="estimate-text">Estimated Total</span>
          <ng-container *ngIf="!hasPendingParts; else pendingTotal">
            <span class="estimated-amount">₹{{ grandTotal }}</span>
          </ng-container>
          <ng-template #pendingTotal>
            <span class="estimated-amount">Will be shared post inspection</span>
          </ng-template>
        </div>

        <p class="note">
          *This is an estimate. Final price will be confirmed after inspection. You'll be notified before billing.
        </p>
      </div>
    </div>

    <div class="service-summary-panel" *ngIf="key == 'laksh'">

      <div class="summary-info-card">
        <h1>{{ serviceDetail.serviceKitDefinition.heading ?? 'Unknown' }}</h1>

        <div class="service-tags">
          <span class="tag">Maintenance</span>
          <span class="dot">•</span>
          <span class="tag">Engine & Filters</span>
        </div>
      <div >
        <div class="service-duration">
          <span class="time-badge">⏱ 2–3 Hours</span>
        </div>
        <div class="service-top-row">

          <div class="time-tag"
              *ngIf="serviceDetail.parts.length && serviceDetail.parts[0]?.deliveryTime">
           ⏱ {{ serviceDetail.parts[0].deliveryTime }}
          </div>

          <div class="service-meta-tag" *ngIf="serviceMetaInfo">
            <div class="meta-line">
              <mat-icon>schedule</mat-icon>
              {{ serviceMetaInfo.time }}
            </div>
            <div class="meta-line">
              <mat-icon>autorenew</mat-icon>
              {{ serviceMetaInfo.interval }}
            </div>
          </div>

        </div>

      </div>
        <div class="feature-badges">
          <span class="feature">✔ Autoverse Assured</span>
          <span class="feature">✔ Genuine Parts</span>
          <span class="feature">✔ Warranty Support</span>
        </div>


        <div class="tags">
            <div class="tag assured"><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 8.5L7.33333 9.83333L10 7.16667M14 8.5C14 9.28793 13.8448 10.0681 13.5433 10.7961C13.2417 11.5241 12.7998 12.1855 12.2426 12.7426C11.6855 13.2998 11.0241 13.7417 10.2961 14.0433C9.56815 14.3448 8.78793 14.5 8 14.5C7.21207 14.5 6.43185 14.3448 5.7039 14.0433C4.97595 13.7417 4.31451 13.2998 3.75736 12.7426C3.20021 12.1855 2.75825 11.5241 2.45672 10.7961C2.15519 10.0681 2 9.28793 2 8.5C2 6.9087 2.63214 5.38258 3.75736 4.25736C4.88258 3.13214 6.4087 2.5 8 2.5C9.5913 2.5 11.1174 3.13214 12.2426 4.25736C13.3679 5.38258 14 6.9087 14 8.5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Autoverse Assured</div>
            <div class="tag genuine"><svg width="16" height="16" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.66667 7.16667V2.5L2.66667 9.83333H7.33334V14.5L13.3333 7.16667H8.66667Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg> Genuine Parts</div>
            
            <div class="tag warranty"><svg width="16" height="16" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 8.50001L7.33334 9.83334L10 7.16668M13.7453 4.48934C11.6374 4.60129 9.57116 3.87242 8 2.46268C6.42885 3.87242 4.3626 4.60129 2.25467 4.48934C2.08502 5.14609 1.99945 5.82171 2 6.50001C2 10.2273 4.54934 13.36 8 14.248C11.4507 13.36 14 10.228 14 6.50001C14 5.80534 13.9113 5.13201 13.7453 4.48934Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>Warranty Support</div>
        </div>

        <div class="price-box">
          <div class="price-label">ESTIMATED PRICE</div>
          <div class="price-value">₹{{ grandTotal || 573}}</div>
          <div class="price-subtext">Final price may vary after inspection</div>
        </div>

        <div class="info-note">
          <mat-icon style="align-items: center; display: flex; font-size: 14px;">info</mat-icon>
          <span>This service uses genuine manufacturer-recommended parts.</span>
        </div>
      </div>
    </div>

    <!-- DENTING & PAINTING PANEL UI -->
    <div class="dp-panel-wrapper" *ngIf="fromPage === 'denting-painting'">
      <div class="fst-txt-div">
          <div class="svg-cls"><svg width="25" height="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 3.33335V2.50002C15 2.04169 14.625 1.66669 14.1667 1.66669H4.16671C3.70837 1.66669 3.33337 2.04169 3.33337 2.50002V5.83335C3.33337 6.29169 3.70837 6.66669 4.16671 6.66669H14.1667C14.625 6.66669 15 6.29169 15 5.83335V5.00002H15.8334V8.33335H7.50004V17.5C7.50004 17.9584 7.87504 18.3334 8.33337 18.3334H10C10.4584 18.3334 10.8334 17.9584 10.8334 17.5V10H17.5V3.33335H15Z" fill="white"/>
            </svg>
          </div>
          <div class="txt-mn-cls">
            <div class="line-fst">Car Painting Rate Card</div>
            <p class="txt-mn-cls-p">Choose the panel you want to paint — transparent pricing, no surprises.</p>
          </div>
      </div>
      <div class="dp-note-box">
        <div class="dp-note-title">
          <span class="warn-icon">⚠</span> Important Note
        </div>

        <ul class="dp-note-list">
          <li>
            Prices shown are valid for
          <br>
            <span class="highlight">minor scratches, surface paint damage & touch-ups only</span>
          </li>
          <li>
            <span class="highlight strong">
              Major dents, deep body damage, rust repair, or structural work are NOT included.
            </span>
          </li>
          <li>Final price may change after physical inspection.</li>
        </ul>
      </div>

      <div class="dp-view-selector">
        <button 
          *ngFor="let view of ['Front','Rear','Full Body','Left','Right']"
          class="dp-view-btn"
          [class.active]="currentView === view"
          (click)="changeView(view)">
          {{ view }}
        </button>
      </div>

      <div class="dp-panels-list">
        <div *ngFor="let panel of dpPanels" class="dp-panel-card-main">

          <div class="dp-panel-card" [class.selected]="panel.selected">
            <div class="dp-panel-left-cmbn" >
              <div class="dp-panel-left">
                <div class="dp-panel-badge">{{ panel.part }}</div>
              </div>

              <div class="dp-panel-info">
                <h4>{{ panel.name }}</h4>
                <p class="dp-panel-sub">Minor Scratch & Paint Only</p>
                <div class="dp-panel-price-main">
                    <div class="dp-panel-price">Starting from</div>
                    <span class="dp-panel-price-span">₹{{ getPanelPrice(panel) }}</span>
                </div>
              </div>
            </div>
            <mat-icon class="info-icon-pnl" (click)="openInfo(panel)">info</mat-icon>
          </div>

          <button
            class="dp-select-btn"
            [class.selected-btn]="panel.selected"
            (click)="togglePanel(panel)"
          >
            {{ panel.selected ? 'Selected ✓' : 'Select Panel' }}
          </button>

        </div>
      </div>

      <div class="dp-info-overlay" *ngIf="activeInfoPanel" (click)="closeInfo()">
        <div class="dp-info-card" (click)="$event.stopPropagation()">
          
          <div class="dp-info-section">
            <div class="dp-info-title includes">✔ Includes:</div>
            <ul>
              <li>Sanding & surface prep</li>
              <li>Premium primer coat</li>
              <li>Base color coat</li>
              <li>Clear coat finish</li>
            </ul>
          </div>

          <div class="dp-info-section">
            <div class="dp-info-title not-includes">✖ Does NOT include:</div>
            <ul>
              <li>Dent pulling or removal</li>
              <li>Welding or body work</li>
              <li>Rust treatment</li>
            </ul>
          </div>

        </div>
      </div>

      <!-- Why Choose Section -->
      <div class="dp-why-section">
        <h3 class="dp-why-title">Why Choose Painting in {{ garageShortName }}?</h3>

        <div class="dp-why-item">
          <div class="dp-why-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.6667 0C5.22667 0 0 5.22667 0 11.6667C0 18.1067 5.22667 23.3333 11.6667 23.3333C18.1067 23.3333 23.3333 18.1067 23.3333 11.6667C23.3333 5.22667 18.1067 0 11.6667 0ZM9.33333 17.5L3.5 11.6667L5.145 10.0217L9.33333 14.1983L18.1883 5.34333L19.8333 7L9.33333 17.5Z" fill="black"/>
            </svg>

          </div>
          <h5>Trained Painters</h5>
          <p>Certified professionals</p>
        </div>

        <div class="dp-why-item">
          <div class="dp-why-icon">
            <svg width="24" height="23" viewBox="0 0 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.6667 0L15.2717 7.30333L23.3333 8.48167L17.5 14.1633L18.8767 22.19L11.6667 18.3983L4.45667 22.19L5.83333 14.1633L0 8.48167L8.06167 7.30333L11.6667 0Z" fill="black"/>
            </svg>

          </div>
          <h5>Premium Materials</h5>
          <p>High-quality paint</p>
        </div>

        <div class="dp-why-item">
          <div class="dp-why-icon">
            <svg width="21" height="26" viewBox="0 0 21 26" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.5 0L0 4.66667V11.6667C0 18.1417 4.48 24.1967 10.5 25.6667C16.52 24.1967 21 18.1417 21 11.6667V4.66667L10.5 0Z" fill="black"/>
            </svg>
          </div>
          <h5>Warranty on Paint</h5>
          <p>6 months guarantee</p>
        </div>

        <div class="dp-why-item">
          <div class="dp-why-icon">
            <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.52167 12.3433L1.65667 7.47833L0 9.12333L6.52167 15.645L20.5217 1.645L18.8767 0L6.52167 12.3433Z" fill="black"/>
            </svg>

          </div>
          <h5>Transparent Pricing</h5>
          <p>No hidden charges</p>
        </div>
      </div>

      <p class="dp-why-footer">
        All prices are indicative. Final quote depends on car model, color type and physical inspection.
      </p>

      <!-- Bottom Bar -->
       <div class="dp-bottom-bar-main" *ngIf="selectedPanels.length > 0">

          <!-- Top Row -->
          <div class="dp-bottom-info">

            <!-- Left -->
            <div class="dp-left">
              <div class="dp-selected-text">Selected Panels</div>
              <div class="dp-selected-count">{{ selectedPanels.length }} Panel</div>
            </div>

            <!-- Right -->
            <div class="dp-right">
              <div class="dp-estimate-label">Estimated Total</div>
              <div class="dp-total-price">₹{{ dpTotal }}</div>
            </div>

          </div>

          <!-- Bottom Button -->
          <button 
            class="dp-inspect-btn" 
            data-bs-toggle="modal" 
            data-bs-target="#requestCallBackModal">
            Proceed for Inspection
          </button>

        </div>
    </div>
  </div>
  <!-- Service Description Card -->
  <div class="service-description-card" *ngIf="fromPage !== 'denting-painting'" id="service-description">
    <h3>Service Description</h3>

    <p [ngClass]="{'collapsed': !showFullDescription}">
      {{ serviceDetail.serviceKitDefinition.description ?? 'Details not available' }}
    </p>
    <button
      *ngIf="serviceDetail.serviceKitDefinition.description?.length > 180"
      class="desc-toggle-btn"
      (click)="toggleDescription()"
    >
      <span>{{ showFullDescription ? 'Show Less' : 'Show More' }}</span>
      <span class="arrow" [class.rotate]="showFullDescription">expand_more</span>
    </button>
  </div>

  <!-- What's included -->
  <!-- <div class="section">
    <h3>What’s included</h3>
    <ul class="checklist">
      <li *ngFor="let item of serviceDetail.whatsIncluded">
        {{ item }}
      </li>
      <li *ngIf="serviceDetail.whatsIncluded.length === 0">No items available.</li>
    </ul>
  </div> -->
    <div class="included-card" *ngIf="serviceDetail.whatsIncluded?.length > 0" id="whats-included">
    <h3>What’s Included</h3>

    <div class="included-item" *ngFor="let item of serviceDetail.whatsIncluded">
      <span class="check-icon">check_circle</span>
      <span class="text">{{ item }}</span>
    </div>
  </div>

  <!-- FAQs -->
  <div class="card-faq-main" *ngIf="serviceDetail.faqs?.length > 0" id="faqs">
    <div class="card faq">
      <h3>Frequently Asked Questions</h3>
      <details *ngFor="let faq of serviceDetail.faqs">
        <summary>{{ faq.question }}
          <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.6666 1.5L5.99998 6.16667L1.33331 1.5" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </summary>
        <p>{{ faq.answer }}</p>
      </details>
      <div *ngIf="serviceDetail.faqs.length === 0">No FAQs available.</div>
    </div>
  </div>
  <!-- Bottom Actions -->
  <div class="actions" *ngIf="fromPage !== 'denting-painting'">
    <div class="price-value">₹{{ grandTotal || 573}}</div>
    <button class="btn primary"  data-bs-toggle="modal" data-bs-target="#requestCallBackModal" style="font-size: 16px;">
      <!-- <mat-icon>bookmark_border</mat-icon> -->
      Book Service
    </button>
  </div>
</div>

</div>

 <!-- ==========requesta-a-call-bac-pop-up======= -->
<div class="modal fade" id="requestCallBackModal" tabindex="-1" aria-labelledby="requestCallBackModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg custom-modal" style=" width: 400px;">
    <div class="modal-content" style="border-radius: 8px; padding: 10px;"> 
        <div class="modal-content-sub" >
        <!-- Header -->
            <div class="d-flex justify-content-between align-items-center mb-3" style=" padding: 10px 20px; margin: 0 !important; background: linear-gradient(to right, #F7FBFF, #FFFFFF); border-radius: 10px;">
                <h3 class="fw-bold m-0" style="font-size: 20px; font-weight: 900 !important; color: #0B2636;">
                <div class="call-icon-and-text">
                    <img src="./assets/img/call-image.png">
                    <div> Customer Details </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                </h3>
            </div>

            <p class="text-muted mb-4" style=" font-size: 14px !important;color: #57738A !important; padding: 5px 20px; margin: 10px 0px !important; font-weight: 400;">
                Leave your details to book a service.
            </p>

            <!-- Form -->
            <form [formGroup]="callbackForm" (ngSubmit)="submitForm()" class="callback-form">

                <div class="form-scroll-area">

                    <!-- Name -->
                    <div class="form-floating mb-3">
                    <input type="text" formControlName="name" class="form-control" id="custName" placeholder="Name">
                    <label for="custName">Name *</label>
                    </div>
                    <div class="text-danger small mb-2"
                        *ngIf="submitted && callbackForm.get('name')?.invalid">
                    Name is required
                    </div>

                    <!-- Mobile -->
                    <div class="form-floating mb-3">
                    <input type="text" formControlName="mobile" class="form-control" id="custMobile" placeholder="Mobile Number" maxlength="10">
                    <label for="custMobile">Mobile Number *</label>
                    </div>
                    <div class="text-danger small mb-2"
                        *ngIf="submitted && callbackForm.get('mobile')?.invalid">
                    <span *ngIf="callbackForm.get('mobile')?.errors?.['required']">Mobile number is required</span>
                    <span *ngIf="callbackForm.get('mobile')?.errors?.['pattern']">Mobile number must be 10 digits</span>
                    </div>

                    <!-- Registration Number -->
                    <div class="form-floating mb-3">
                    <input type="text" formControlName="registrationNumber" (input)="formatRegistrationNumber()" class="form-control" id="regNo" placeholder="KA 03 MX 5059">
                    <label for="regNo">Registration Number *</label>
                    </div>
                    <div class="text-danger small mb-2"
                        *ngIf="submitted && callbackForm.get('registrationNumber')?.invalid">
                    <span *ngIf="callbackForm.get('registrationNumber')?.errors?.['required']">Registration number is required</span>
                    <span *ngIf="callbackForm.get('registrationNumber')?.errors?.['pattern']">Format must be like KA 03 MX 4048</span>
                    </div>

                    <!-- Email -->
                    <div class="form-floating mb-3">
                    <input type="email" formControlName="email" class="form-control" id="custEmail" placeholder="Email">
                    <label for="custEmail">Email (Optional)</label>
                    </div>
                </div>

                <!-- Sticky Button -->
                <div class="form-footer">
                    <button type="submit" class="btn btn-primary w-100 submit-btn">
                    Submit Details
                    </button>
                </div>

            </form>
        </div>

    </div>
  </div>
</div>

  <!-- Success Confirmation Modal -->
  <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" style="width: 30%;">
      <div class="modal-content text-center">
        <div class="modal-body">
          <p style="margin-bottom: 0;">{{ successMessage }}</p>
          <p style="color: green; font-size: 100px;"><i class="uil uil-check-circle"></i></p>
          <p class="lead mb-6">We will call you shortly</p>
          <button type="button" class="btn btn-secondary rounded-pill btn-login w-100 mb-2" (click)="closeSuccessModal()" style="background: #144579;">OK</button>
        </div>
      </div>
    </div>
  </div>

<app-loading *ngIf="loading"></app-loading>